import React, { useState, useEffect, createContext } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import ModelUnit from './components/ModelUnit';
import ModelDetail from './components/ModelDetail/PageParent';
import NewModel from './components/NewModel';
import Login from './components/Login';
import PoolUnit from './components/Pool/PoolUnit';
import Profile from './components/Profile'; // Import your Profile component
import ProtectedRoute from './components/ProtectedRoute';
import CastingUnit from './components/Pool/Casting/CastingUnit';
import BookingUnit from './components/Pool/Booking/BookingUnit';
import BookingConfirmationUnit from './components/Pool/Booking/BookingConfirmationUnit';
import CallTimes from './components/Production/CallTimes';
import Billing from './components/Production/Billing';

export const SiteContext = createContext();

function App() {
    const [isEditMode, setIsEditMode] = useState(false);
    const [exportModelToPDF, setExportModelToPDF] = useState(null);

    const [authenticated, setAuthenticated] = useState(
        () => localStorage.getItem('authenticated') === 'true'
    );

    // Log out logic
    const logout = () => {
        localStorage.removeItem('authenticated');
        setAuthenticated(false);
    };

    return (
        <Router>
            <div className="App">
                <SiteContext.Provider value={{ isEditMode, setIsEditMode, exportModelToPDF, setExportModelToPDF }}>
                    <Navbar logout={logout} />
                    <Routes>
                        <Route
                            path="/login"
                            element={<Login setAuthenticated={setAuthenticated} />}
                        />
                        <Route
                            path="/"
                            element={
                                <ProtectedRoute authenticated={authenticated}>
                                    <ModelUnit />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/pool-unit"
                            element={
                                <ProtectedRoute authenticated={authenticated}>
                                    <PoolUnit />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/castings"
                            element={
                                <ProtectedRoute authenticated={authenticated}>
                                    <CastingUnit />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/bookings"
                            element={
                                <ProtectedRoute authenticated={authenticated}>
                                    <BookingUnit />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/bookingConfirmationUnit"
                            element={
                                <ProtectedRoute authenticated={authenticated}>
                                    <BookingConfirmationUnit />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/new-model"
                            element={
                                <ProtectedRoute authenticated={authenticated}>
                                    <NewModel />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/model/:id"
                            element={
                                <ProtectedRoute authenticated={authenticated}>
                                    <ModelDetail />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/callTimes"
                            element={
                                <ProtectedRoute authenticated={authenticated}>
                                    <CallTimes />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/billing"
                            element={
                                <ProtectedRoute authenticated={authenticated}>
                                    <Billing />
                                </ProtectedRoute>
                            }
                        />
                        {/* Profile Routes */}
                        <Route
                            path="/profile"
                            element={
                                <ProtectedRoute authenticated={authenticated}>
                                    <Profile mode="user" /> {/* Normal user profile */}
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/profile/admin"
                            element={
                                <ProtectedRoute authenticated={authenticated}>
                                    <Profile mode="admin" /> {/* Admin profile */}
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/profile/admin/edit"
                            element={
                                <ProtectedRoute authenticated={authenticated}>
                                    <Profile mode="admin_edit" /> {/* Admin editing another profile */}
                                </ProtectedRoute>
                            }
                        />
                    </Routes>
                </SiteContext.Provider>
            </div>
        </Router>
    );
}

export default App;
